import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import Home from "../views/Home/index.vue";
import SL from "../views/SL/index.vue";
import Recharge from "../views/recharge/index.vue";
import Stripe from "../views/stripe/index.vue";
import Scheme from "../views/scheme.vue";
import ChimoHome from "../views/Home/main-home.vue";
import ChimoRecharge from "../views/recharge/oumi_recharge.vue";
const routes = [
  {
    path: "/",
    component: ChimoHome,
    meta: { hideHeader: true },
  },
  {
    path: "/SL",
    component: SL,
  },
  {
    path: "/recharge",
    name: "recharge",
    // component: Recharge,
    component: ChimoRecharge,
  },
  {
    path: "/stripe",
    name: "stripe",
    component: Stripe,
    meta: { hideHeader: true }
  },
  {
    path:"/scheme",
    name:"scheme",
    component:Scheme,
  }
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes: routes,
});

export default router;
